module.exports = __webpack_public_path__ + "img/play.91bf5b51.svg";